import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {catchError, map, Observable, of, take, timeout} from 'rxjs';
import {ApiResponse} from '@models/api.response';
import {buildPath} from '@utils/util-builder';

/**
 * Protege las rutas del módulo SIROC. Consulta en vivo el acceso del usuario
 * autenticado (backend resuelve según rol y feature flag is_siroc). Si no tiene
 * acceso, redirige a 404.
 */
@Injectable({
    providedIn: 'root'
})
export class SirocEnabledGuard  {
    constructor(private readonly _http: HttpClient, private readonly _router: Router) {
    }

    canActivate(): Observable<boolean> {
        const url: string = buildPath(['data-core/api/siroc/acceso']);
        return this._http.get<ApiResponse<boolean>>(url).pipe(
            take(1),
            map((response: ApiResponse<boolean>): boolean => {
                const allowed: boolean = response?.data === true;
                if (!allowed) {
                    void this._router.navigate(['/404-not-found']);
                }
                return allowed;
            }),
            timeout(5000),
            catchError((e) => {
                console.error('Error checking SIROC access:', e);
                void this._router.navigate(['/404-not-found']);
                return of(false);
            })
        );
    }
}
